import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import Table from 'common/components/table/table-material';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsersSubscriptionActionsList } from '../subscribeProductActions';
import { formatToBrPhone } from 'helpers/utils';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const exportToExcel = (csvData, fileName) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-T';
  const fileExtension = '.xlsx';
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  saveAs(data, fileName + fileExtension);
};

const RECURRENCE_LABELS = {
  weekly: 'Semanal',
  biweekly: 'Quinzenal',
  monthly: 'Mensal',
  bimonthly: 'Bimestral',
  quarterly: 'Trimestral',
  semiannual: 'Semestral',
  halfyearly: 'Semestral',
  annual: 'Anual',
  yearly: 'Anual',
};

const PAYMENT_LABEL = {
  credit_card: 'Cartão de crédito',
  pix: 'PIX',
};

function UsersSubscriptionActions(props) {
  const { auth } = props;
  const listUsersSubscriptions = props.subscribeProduct.listUsersSubscriptions;
  const { router } = props;

  const defaultColumns = [
    { title: 'Nome', field: 'name' },
    {
      title: 'CPF',
      field: 'cpf',
      render: (rowData) => {
        const cpf = rowData.cpf?.padStart(11, '0') || '';
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      },
    },
    {
      title: 'Tel.',
      field: 'tel',
      render: (rowData) => formatToBrPhone(rowData.tel),
    },
    { title: 'E-mail', field: 'email' },
    { title: 'Estação', field: 'station' },
    { title: 'Código', field: 'code' },
    { title: 'Produto', field: 'subscription_description' },
    { title: 'Quantidade', field: 'total_inscricoes', type: 'numeric' },
    {
      title: 'Valor (R$)',
      field: 'price',
      type: 'currency',
      render: (rowData) =>
        Number(rowData.price).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    { title: 'Taxa (%)', field: 'tax', render: (rowData) => `${Number(rowData.tax).toFixed(1)}%` },
    {
      title: 'Líquido (R$)',
      field: 'price_minus_8_3_percent',
      render: (rowData) =>
        Number(rowData.price_minus_8_3_percent).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      title: 'Forma de Pagamento',
      field: 'payment_type',
      render: (rowData) => PAYMENT_LABEL[rowData.payment_type],
    },
    {
      title: 'Data da primeira compra',
      field: 'subscription_date',
      render: (rowData) =>
        new Date(rowData.subscription_date).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }),
    },
    {
      title: 'Status primeira compra',
      field: 'is_first_subscription_paid',
      render: (rowData) =>
        rowData.is_first_subscription_paid ? 'Pagamento confirmado' : 'Pagamento pendente',
    },
    {
      title: 'Recorrência',
      field: 'recurrence',
      render: (rowData) => `${RECURRENCE_LABELS[rowData.recurrence]}`,
    },
    { title: 'Pagas', field: 'total_pago', render: (rowData) => `${rowData.total_pago}` },
    {
      title: 'Pendentes',
      field: 'total_pendente',
      render: (rowData) => `${rowData.total_pendente}`,
    },
    {
      title: 'Canceladas',
      field: 'total_cancelado',
      render: (rowData) => `${rowData.total_cancelado}`,
    },
  ];

  // Nova função para preparar os dados para exportação
  const getExportableData = (dataToExport) => {
    return dataToExport.map((row) => {
      const exportableRow = {};
      defaultColumns.forEach((col) => {
        if (col.render) {
          exportableRow[col.title] = col.render(row);
        } else {
          exportableRow[col.title] = row[col.field];
        }
      });
      return exportableRow;
    });
  };

  function onRowClick(e) {
    props.router.push(`/owner/acoes/assinar-produto/relatorio-assinaturas`);
  }
  const columns = defaultColumns;

  const [data, setData] = useState([]);

  useEffect(() => {
    props.getUsersSubscriptionActionsList(auth.user.establishments[0].stations[0].id);
  }, []);

  useEffect(() => {
    setData(props.subscribeProduct.listUsersSubscriptions);
  }, [props.subscribeProduct.listUsersSubscriptions]);

  function renderEmptyScreen() {
    return (
      <section id="user-subscription-action-report">
        <GeneralGrid container spacing={3} alignItems="center">
          <GeneralGrid item xs={12} md={6}>
            <GeneralGrid container spacing={3}>
              <GeneralGrid item xs={12}>
                <div className="pl-4">
                  <h2 className="signup-text">
                    Estação ainda não possui atividades de assinaturas com assinantes.
                  </h2>
                </div>
              </GeneralGrid>
            </GeneralGrid>
          </GeneralGrid>
          <GeneralGrid item xs={12} md={6}>
            <img alt="" src={placeholder_illustration} className="img-fluid" />
          </GeneralGrid>
        </GeneralGrid>
      </section>
    );
  }

  if (props.subscribeProduct.loading) {
    return (
      <Box display="flex" justifyContent="center" mt={7}>
        <LoadingProgress />
      </Box>
    );
  }
  if (listUsersSubscriptions.length < 1) {
    return renderEmptyScreen();
  }

  const exportableData = getExportableData(data);

  return (
    <section>
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12}>
          <GeneralGrid container spacing={3}>
            <GeneralGrid item xs={12}>
              <Table
                hasToolbar
                toolbarSearch
                title="Lista de Assinantes"
                columns={columns}
                rows={data}
                onRowClick={onRowClick}
                router={router}
                mobileTable={isMobile}
                hasBorder={!isMobile}
                buttonCSV
                csvData={exportableData} // Usa os dados formatados
                onExportClick={() => exportToExcel(exportableData, 'relatorio_assinantes')} // Usa os dados formatados
              />
            </GeneralGrid>
          </GeneralGrid>
        </GeneralGrid>
      </GeneralGrid>
    </section>
  );
}

const mapStateToProps = (state) => {
  return {
    subscribeProduct: state.subscribeProduct,
    auth: state.auth,
    general: state.general,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getUsersSubscriptionActionsList }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersSubscriptionActions);
